export default {
	ballWhite: '/game-images/volley/ball-white.png',
	ballYellow: '/game-images/volley/ball-yellow.png',
	net: '/game-images/volley/net.png',
	shadow: '/game-images/volley/shadow.png',
	background: {
		beach: '/game-images/volley/background/beach.jpg',
		city: '/game-images/volley/background/city.jpg',
		backyard: '/game-images/volley/background/backyard.jpg',
		desert: '/game-images/volley/background/desert.jpg',
		garden: '/game-images/volley/background/garden.jpg'
	},
	dummy: {
		green: {
			left: {
				running: [
					'/game-images/volley/dummy/green/left/running/1.png',
					'/game-images/volley/dummy/green/left/running/2.png',
					'/game-images/volley/dummy/green/left/running/3.png',
					'/game-images/volley/dummy/green/left/running/4.png'
				],
				jumping: [
					'/game-images/volley/dummy/green/left/jumping/1.png',
					'/game-images/volley/dummy/green/left/jumping/2.png'
				],
				idle: [
					'/game-images/volley/dummy/green/left/idle/1.png',
					'/game-images/volley/dummy/green/left/idle/2.png'
				]
			},
			right: {
				running: [
					'/game-images/volley/dummy/green/right/running/1.png',
					'/game-images/volley/dummy/green/right/running/2.png',
					'/game-images/volley/dummy/green/right/running/3.png',
					'/game-images/volley/dummy/green/right/running/4.png'
				],
				jumping: [
					'/game-images/volley/dummy/green/right/jumping/1.png',
					'/game-images/volley/dummy/green/right/jumping/2.png'
				],
				idle: [
					'/game-images/volley/dummy/green/right/idle/1.png',
					'/game-images/volley/dummy/green/right/idle/2.png'
				]
			}
		},
		yellow: {
			left: {
				running: [
					'/game-images/jumper/dummy/yellow/left/running/1.png',
					'/game-images/jumper/dummy/yellow/left/running/2.png',
					'/game-images/jumper/dummy/yellow/left/running/3.png',
					'/game-images/jumper/dummy/yellow/left/running/4.png',
					'/game-images/jumper/dummy/yellow/left/running/5.png'
				],
				jumping: [
					'/game-images/jumper/dummy/yellow/left/jumping/1.png',
					'/game-images/jumper/dummy/yellow/left/jumping/2.png'
				],
				idle: [
					'/game-images/jumper/dummy/yellow/left/idle/1.png',
					'/game-images/jumper/dummy/yellow/left/idle/2.png'
				]
			},
			right: {
				running: [
					'/game-images/jumper/dummy/yellow/right/running/1.png',
					'/game-images/jumper/dummy/yellow/right/running/2.png',
					'/game-images/jumper/dummy/yellow/right/running/3.png',
					'/game-images/jumper/dummy/yellow/right/running/4.png',
					'/game-images/jumper/dummy/yellow/right/running/5.png'
				],
				jumping: [
					'/game-images/jumper/dummy/yellow/right/jumping/1.png',
					'/game-images/jumper/dummy/yellow/right/jumping/2.png'
				],
				idle: [
					'/game-images/jumper/dummy/yellow/right/idle/1.png',
					'/game-images/jumper/dummy/yellow/right/idle/2.png'
				]
			}
		}
	}
};
